module.exports = __webpack_public_path__ + "static/media/Combo Chengzhi_Web2025.1537d402.png";